<template>
  <div class="p-6 space-y-10">
    <div>
      <h1 class="text-2xl font-bold text-black-200 mb-4">
        Categorização {{ enterpriseName }}
      </h1>
      <div class="overflow-x-auto">
        <table
          class="min-w-full text-sm text-black-300 bg-white-800 rounded-lg shadow"
        >
          <thead class="bg-blue-700 text-xs uppercase text-gray-400">
            <tr>
              <th class="px-4 py-2">Categorização</th>
              <th class="px-4 py-2">Total de controles</th>
              <th class="px-4 py-2">Não aplicaveis</th>
              <th class="px-4 py-2">Implementados</th>
              <th class="px-4 py-2">Parciais</th>
              <th class="px-4 py-2">Não implementados</th>
              <th class="px-4 py-2">Aderente</th>
              <th class="px-4 py-2">Não Aderente</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in filteredCategories"
              :key="item._id"
              class="border-b border-blue-700 hover:bg-gray-200 transition"
            >
              <td class="px-4 py-2 text-center">Controles Organizationais</td>
              <td class="px-4 py-2 text-center">
                {{ item.OrganizationalControl }}
              </td>
              <td class="px-4 py-2 text-center">{{ 0 }}</td>
              <td class="px-4 py-2 text-center">
                {{ item.OrganizationalControlImplemented }}
              </td>
              <td class="px-4 py-2 text-center">
                {{ item.OrganizationalControlPartiallyImplemented }}
              </td>
              <td class="px-4 py-2 text-center">
                {{ item.OrganizationalControlNotImplemented }}
              </td>
              <td class="px-4 py-2 text-center">{{ 0 }}</td>
              <td class="px-4 py-2 text-center">{{ 0 }}</td>
            </tr>
            <tr
              v-for="item in filteredCategories"
              :key="item._id"
              class="border-b border-blue-700 hover:bg-gray-200 transition"
            >
              <td class="px-4 py-2 text-center">Controles de Pessoas</td>
              <td class="px-4 py-2 text-center">{{ item.PeopleControl }}</td>
              <td class="px-4 py-2 text-center">
                {{ item.PeoplesControlNotApplicable }}
              </td>
              <td class="px-4 py-2 text-center">
                {{ item.PeopleControlImplemented }}
              </td>
              <td class="px-4 py-2 text-center">
                {{ item.PeopleControlPartiallyImplemented }}
              </td>
              <td class="px-4 py-2 text-center">
                {{ item.PeopleControlNotImplemented }}
              </td>
              <td class="px-4 py-2 text-center">{{ 0 }}</td>
              <td class="px-4 py-2 text-center">{{ 0 }}</td>
            </tr>
            <tr
              v-for="item in filteredCategories"
              :key="item._id"
              class="border-b border-blue-700 hover:bg-gray-200 transition"
            >
              <td class="px-4 py-2 text-center">Controles Físicos</td>
              <td class="px-4 py-2 text-center">{{ item.PhysicalControl }}</td>
              <td class="px-4 py-2 text-center">
                {{ item.PhysicalControlNotApplicable }}
              </td>
              <td class="px-4 py-2 text-center">
                {{ item.PhysicalControlImplemented }}
              </td>
              <td class="px-4 py-2 text-center">
                {{ item.PhysicalControlPartiallyImplemented }}
              </td>
              <td class="px-4 py-2 text-center">
                {{ item.PhysicalControlNotImplemented }}
              </td>
              <td class="px-4 py-2 text-center">{{ 0 }}</td>
              <td class="px-4 py-2 text-center">{{ 0 }}</td>
            </tr>
            <tr
              v-for="item in filteredCategories"
              :key="item._id"
              class="border-b border-blue-700 hover:bg-gray-200 transition"
            >
              <td class="px-4 py-2 text-center">Controles Tecnológicos</td>
              <td class="px-4 py-2 text-center">
                {{ item.TechnologicalControl }}
              </td>
              <td class="px-4 py-2 text-center">
                {{ item.TechnologicalControlNotApplicable }}
              </td>
              <td class="px-4 py-2 text-center">
                {{ item.TechnologicalControlImplemented }}
              </td>
              <td class="px-4 py-2 text-center">
                {{ item.TechnologicalControlPartiallyImplemented }}
              </td>
              <td class="px-4 py-2 text-center">
                {{ item.TechnologicalControlNotImplemented }}
              </td>
              <td class="px-4 py-2 text-center">{{ 0 }}</td>
              <td class="px-4 py-2 text-center">{{ 0 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCategories,
  getCategoriesbyIdEnterprise,
} from '@/services/graphs/api.categorization'

export default {
  props: {
    idEnterprise: {
      type: String,
      required: true,
    },
    enterpriseName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      allCategories: [],
      filteredCategories: [],
    }
  },
  async mounted() {
    try {
      const [all, filtered] = await Promise.all([
        getCategories(),
        getCategoriesbyIdEnterprise(this.idEnterprise),
      ])
      this.allCategories = all
      this.filteredCategories = filtered
    } catch (error) {
      console.error('Erro ao buscar dados de categorização:', error)
    }
  },
}
</script>
